function isFirefox(): boolean {
  return typeof navigator !== 'undefined' && /firefox/i.test(navigator.userAgent);
}

export function shouldUsePrintFallbackWindow(): boolean {
  return isFirefox();
}

export function printPdfBlob(blob: Blob, fallbackWindow?: Window | null): void {
  const url = URL.createObjectURL(blob);

  if (fallbackWindow) {
    fallbackWindow.location.href = url;
    globalThis.setTimeout(() => URL.revokeObjectURL(url), 60_000);

    return;
  }

  const iframe = document.createElement('iframe');

  iframe.style.display = 'none';
  iframe.src = url;

  iframe.onload = () => {
    try {
      iframe.contentWindow?.focus();
      iframe.contentWindow?.print();
    } catch {
      window.open(url, '_blank');
    }

    globalThis.setTimeout(() => {
      iframe.remove();
      URL.revokeObjectURL(url);
    }, 60_000);
  };

  document.body.appendChild(iframe);
}
